{
    "Quick-Search-Fields": [
        {
            "label": "VenueName",
            "columnname": "VenueName",
            "placeholder": "VenueName",
            "width": "",
            "datatype": "string",
            "isLarge": false
        },
        {
            "label": "Symbol",
            "columnname": "Symbol",
            "placeholder": "Symbol",
            "width": "",
            "datatype": "string",
            "isLarge": false
        },
        {
            "label": "OrderID",
            "columnname": "OrderID",
            "placeholder": "OrderID",
            "width": "",
            "datatype": "string",
            "isLarge": true
        },
        {
            "label": "Source",
            "columnname": "Source",
            "placeholder": "Source",
            "width": "",
            "datatype": "string",
            "isLarge": false
        }
    ],
    "Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "action",
            "db_columnname": "action",
            "datatype": "char",
            "mappingkey": "action",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "isSynthesized",
            "db_columnname": "isSynthesized",
            "datatype": "boolean",
            "mappingkey": "isSynthesized",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ]
}
